import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import { richiestaStream } from "../lib/richiesta_stream"

// StatoVoce di components/StatoVoce.js (31a5bd1), su progetti/passo3/_stato_voce: «Documenta la condizione» (o «Motiva
// il punto applicabile») apre il modulo e sparisce finché è aperto (apri); «Conferma con evidenza» è attivo con
// un'evidenza di almeno 3 caratteri e una motivazione di almeno 10 (trim), mai mentre una richiesta è in corso (busy).
// invia: POST a urlValue { tipo, riga_id (quella scelta o la prima), riferimento, motivazione, documento_id (o null) };
// se riesce il modulo si chiude e si svuota (setApri(false) e i campi azzerati) e il turbo-stream porta il toast e le
// voci salvate con lo stato nuovo (onScenario: le modifiche non ancora salvate restano sopra di esse, voci_editor);
// se non riesce resta aperto con il toast (il `detail` della risposta, o «Non riuscito»). revoca: POST all'indirizzo
// della conferma. Un rinvio (sessione scaduta, verifica in due passaggi) apre la pagina a cui rimanda.
export default class extends Controller {
  static targets = ["apri", "form", "riga", "riferimento", "documento", "motivazione", "invia", "occupato"]
  static values = { url: String, tipo: String }

  connect() {
    this.busy = false
  }

  apri() {
    this.formTarget.hidden = false
    this.apriTarget.hidden = true
    this.controlla()
  }

  annulla() {
    this.formTarget.hidden = true
    this.apriTarget.hidden = false
  }

  controlla() {
    if (!this.hasInviaTarget) return
    this.inviaTarget.disabled = this.busy || this.riferimentoTarget.value.trim().length < 3 || this.motivazioneTarget.value.trim().length < 10
  }

  async invia() {
    const corpo = {
      tipo: this.tipoValue, riga_id: this.rigaTarget.value || this.rigaTarget.options[0]?.value, riferimento: this.riferimentoTarget.value,
      motivazione: this.motivazioneTarget.value, documento_id: (this.hasDocumentoTarget && this.documentoTarget.value) || null,
    }
    await this.richiesta(this.urlValue, corpo, () => {
      this.riferimentoTarget.value = ""
      this.motivazioneTarget.value = ""
      if (this.hasDocumentoTarget) this.documentoTarget.value = ""
      this.annulla()
    })
  }

  revoca(event) {
    return this.richiesta(event.params.url)
  }

  async richiesta(url, corpo, riuscita) {
    if (this.busy) return
    this.occupa(true)
    const r = await richiestaStream(url, { corpo })
    if (r?.ok && riuscita) riuscita()
    this.occupa(false)
    if (r) Turbo.renderStreamMessage(r.testo)
  }

  occupa(si) {
    this.busy = si
    this.occupatoTargets.forEach((b) => { b.disabled = si })
    this.controlla()
  }
}
